export default {
  getHostReferenceData: state => state.hostReferenceData,
  getTenantReferenceData: state => state.tenantReferenceData,
}
